import { Location, NgClass } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Event, Router } from '@angular/router';
import { environment } from 'environments/environment';
import { ButtonComponent } from 'ngx-carnival-tourbo-components';
import { StateScreenService } from 'services/state-screen/state-screen.service';
import { AutocompleteComponent } from '../../autocomplete/autocomplete.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  startWith,
  switchMap,
} from 'rxjs';
import { AgenciesService } from '@modules/flights/services/agencies.service';
import { UserDTO } from '@modules/auth/interfaces/userinfo.response.dto';
import { MatMenuModule } from '@angular/material/menu';
import { BrowserStorageService } from '@modules/auth/services/browser-storage.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UserService } from '@modules/auth/services/user.service';
import { AuthService } from '@modules/auth/services/auth.service';
import { MatRadioModule } from '@angular/material/radio';
import { ConsolidatorsResponseDTO } from '@modules/auth/interfaces/consolidator.response.dto';
import { TabContextService } from '@modules/auth/services/tab-context.service';
import { CurrencyViewService } from '@modules/flights/services/currency-view.service';

@Component({
  selector: 'cv-header',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    ButtonComponent,
    NgClass,
    AutocompleteComponent,
    MatMenuModule,
    MatTooltipModule,
    MatRadioModule,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent {
  @ViewChild('componenteContainer') container!: TemplateRef<unknown>;
  @ViewChild('consolidatorModalTemplate')
  consolidatorModalTemplate!: TemplateRef<unknown>;

  isMobile = false;
  currentRoute: string = '';
  environmentHeading = environment.heading;
  env: string = '';

  user!: UserDTO;
  ref: any;
  agency: FormControl = new FormControl<string>('');
  options: any[] = [];
  loading: boolean = false;
  selectionMade: boolean = true;
  agencyName = '';
  buttonDisabled = true;
  imageUrl: string = '../../../../assets/img/logo-tourbo.svg';
  isMenu? = false;
  isJump = false;
  isSet = false;
  isWhiteLabel = false;

  // Consolidator selection
  consolidatorName = '';
  consolidatorOptions: Array<{ name: string; id: string }> = [];
  selectedConsolidatorIndex: number = 0;
  consolidatorLoading: boolean = false;
  consolidatorButtonDisabled = true;
  consolidatorsCached: boolean = false;
  selectionRequired: boolean = false;
  constructor(
    private _stateScreenService: StateScreenService,
    private location: Location,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    private agencyService: AgenciesService,
    private browserStorageService: BrowserStorageService,
    private userService: UserService,
    private authService: AuthService,
    private tabCtx: TabContextService,
    public currencyView: CurrencyViewService,
  ) {
    this.env = environment.heading;
    this.getStateScreen();
    this.getCurrentRoute();
  }

  ngOnInit() {
    if (window.location.href.includes('jump-v1.flaptek.com')) {
      this.isJump = true;
    }
    this.setImageUrl();
    this.userService.user$.subscribe((user) => {
      if (user) {
        this.user = user;
        this.currencyView.init(user?.agency?.preferredCurrency);
        const storedAgency = this.tabCtx.getAgency();
        this.agencyName = storedAgency?.name ?? this.user?.agency?.agency_name;
        this.isSet = !!storedAgency;

        // Mientras el usuario está en el flujo de auto-login, no cargar
        // ningún consolidador hasta que lo seleccione en la card.
        const isOnAutoLogin = this.location.path().includes('/auth/auto-login');

        const storedConsolidator = this.tabCtx.getConsolidator();
        if (storedConsolidator) {
          this.consolidatorName = storedConsolidator.name;
        } else {
          const fallbackId = this.tabCtx.getConsolidatorId();
          if (fallbackId) this.consolidatorName = fallbackId;
        }

        if (this.user?.agency?.isChild && !isOnAutoLogin) {
          this.loadConsolidators();
        }
      }
    });
    this.agency.valueChanges
      .pipe(
        startWith(''),
        debounceTime(300),
        distinctUntilChanged(),
        filter((value) => {
          if (this.selectionMade) {
            this.selectionMade = false;
            return false;
          }
          return value ? value.length >= 3 || value == '' : true;
        }),
        switchMap(async (value) => {
          if (value && value.length >= 3) {
            return this.searchAgency(value);
          } else {
            this.loading = false;
            this.options = [];
          }
          return [];
        }),
      )
      .subscribe();
  }

  getStateScreen() {
    this._stateScreenService.mobile$.subscribe({
      next: (state) => {
        this.isMobile = state;
      },
    });
  }
  goBack() {
    if (
      this.currentRoute == '/results' ||
      this.currentRoute.includes('/booking')
    )
      this.goHome();
    else this.location.back();
  }

  getCurrentRoute() {
    this.router.events.subscribe((event: Event) => {
      this.setRoute();
    });
  }
  setRoute() {
    let currentRoute = this.activatedRoute;
    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }
    this.currentRoute = this.location.path();
  }
  openModal() {
    this.buttonDisabled = true;
    this.ref = this.dialog.open(this.container, {
      width: this.isMobile ? '328px' : '414px',
      panelClass: 'modal',
    }) as MatDialogRef<any, any>;
  }

  searchAgency(value: string) {
    this.loading = true;
    this.agencyService.getAgencies({ query: value }).subscribe({
      next: (agencies) => {
        let arrayAgencies: any[] = [];
        agencies.length > 0
          ? agencies.map((agency) => {
              arrayAgencies.push({
                name: agency.agencyName,
                id: agency.delegatorId,
                agencyId: agency.id,
                address: agency.address,
                phone: agency.phone,
                imageProfile: agency.imageProfile,
                parentAgency: agency.parentAgency,
                agencyKind: agency.agencyKind,
              });
            })
          : (arrayAgencies = [{ name: 'No se encontraron resultados' }]);
        this.options = arrayAgencies;
        this.loading = false;
        return '';
      },
    });
  }

  onOptionSelected() {
    this.selectionMade = true;
    this.buttonDisabled = false;
  }
  close() {
    this.agency.setValue('');
    this.ref.close();
  }
  apply() {
    this.agencyName = this.agency.value;
    const selectedAgency = this.options.find(
      (agency) => agency.name == this.agencyName,
    );
    this.tabCtx.setAgency(selectedAgency);
    this.isSet = true;
    // La nueva agencia puede tener otra config de moneda; limpiar la vista persistida.
    this.currencyView.reset();
    this.close();
    window.location.reload();
  }
  deleteAgency() {
    this.tabCtx.clearAgency();
    this.agencyName = this.user?.agency?.agency_name;
    this.isSet = false;
    this.currencyView.reset();
    window.location.reload();
  }

  /** Cambia la moneda de visualización (solo display, no afecta lo que viaja al back). */
  selectViewCurrency(code: string) {
    this.currencyView.setViewCurrency(code);
  }
  goHome() {
    this.router.navigate(['/']);
  }

  setImageUrl(): void {
    const currentUrl = this.currentHref;
    switch (true) {
      case currentUrl.includes('grupo8-v1.flaptek.com'):
      case currentUrl.includes('app.dev.emissions.consolidator.tourboplus.com'):
        this.imageUrl = '../../../../assets/img/logo-grupo8.svg';
        break;
      case currentUrl.includes('jump-v1.flaptek.com'):
        this.imageUrl = '../../../../assets/img/jump-logo.svg';
        break;
      case currentUrl.includes('nites-v1.flaptek.com'):
        this.imageUrl = '../../../../assets/img/nites-logo.svg';
        break;
      case currentUrl.includes('traveltips-v1.flaptek.com'):
        this.imageUrl = '../../../../assets/img/logo-traveltip.png';
        break;
      case currentUrl.includes('felizviaje-v1.flaptek.com'):
        this.imageUrl = '../../../../assets/img/logo-felizviaje.png';
        break;
      case currentUrl.includes('betheworld-v1.flaptek.com'):
        this.imageUrl = '../../../../assets/img/logo-betheworld.svg';
        break;
      case currentUrl.includes('kamchatka-v1.flaptek.com'):
        this.imageUrl = '../../../../assets/img/logo-kamchatka.png';
        break;
      case currentUrl.includes('aereos.sumatraviajes.com'):
        this.imageUrl = '../../../../assets/img/logo-sumatra.png';
        break;
      case currentUrl.includes('aereos.flaptek.com'):
        this.imageUrl = '../../../../assets/img/logo-flaptek.svg';
        break;
      case currentUrl.includes('servicios.snuggle.travel'):
        this.imageUrl = '../../../../assets/img/logo-snuggle.png';
        break;
      case currentUrl.includes('helius-v1.flaptek.com'):
        this.imageUrl = '../../../../assets/img/logo-helius.svg';
        break;
      case currentUrl.includes('easywings-v1.flaptek.com'):
        this.imageUrl = '../../../../assets/img/logo-mediterranea.png';
        break;
      case currentUrl.includes('planisferio-v1.flaptek.com'):
        this.imageUrl = '../../../../assets/img/logo-planisferio.svg';
        break;
      default:
        this.imageUrl = '../../../../assets/img/logo-tourbo.svg';
        break;
    }
    this.isWhiteLabel =
      this.imageUrl !== '../../../../assets/img/logo-tourbo.svg';
  }
  includes() {
    return this.currentRoute.includes('/auth');
  }
  private get currentHref(): string {
    return window.location.href;
  }

  /**
   * Reload duro. Es lo que ya hacen el guard, el interceptor y search: tira
   * abajo la app entera para que ningún singleton `providedIn: 'root'`, timer
   * o request en vuelo pueda reescribir el storage recién limpiado.
   */
  private hardRedirect(url: string): void {
    window.location.href = url;
  }

  logout() {
    this.tabCtx.clearAll();
    this.tabCtx.clearInheritTicket();
    this.currencyView.reset();
    this.authService.logout();
    this.browserStorageService.removeItem('refresh_token');
    const href = this.currentHref;
    if (href.includes('tourbo.com') || href.includes('localhost')) {
      this.hardRedirect(`${environment.appUrlTourbohome}/auth/login`);
    } else {
      this.hardRedirect('/auth');
    }
  }
  includesGrupo8() {
    return window.location.href.includes(
      'app.dev.emissions.consolidator.tourboplus.com',
    );
  }
  redirect() {
    this.router.navigate(['/profile']);
  }
  includesProfile() {
    return this.currentRoute.includes('/profile');
  }

  isChildAgency(): boolean {
    return this.user?.agency?.isChild === true;
  }

  hasConsolidator(): boolean {
    return !!this.consolidatorName || this.consolidatorOptions.length > 1;
  }

  canChangeConsolidator(): boolean {
    return this.consolidatorOptions.length > 1;
  }

  openConsolidatorModal() {
    this.showConsolidatorModal();
  }

  private loadConsolidators() {
    if (this.consolidatorsCached) return;

    const agencyId = this.user?.agency?.agencyId;
    if (!agencyId) return;

    this.consolidatorLoading = true;
    this.selectionRequired = false;

    this.agencyService.getConsolidators(agencyId).subscribe({
      next: (response) => {
        this.selectionRequired = response.selectionRequired;
        this.consolidatorsCached = true;
        this.consolidatorLoading = false;

        if (!response.selectionRequired) {
          const onlyConsolidator = response.consolidators[0];
          if (onlyConsolidator && !this.tabCtx.getConsolidatorId()) {
            this.tabCtx.setConsolidatorId(onlyConsolidator.consolidatorId);
          }
          return;
        }

        this.consolidatorOptions = response.consolidators.map((c) => ({
          name: c.consolidatorName,
          id: c.consolidatorId,
        }));

        const currentId = this.tabCtx.getConsolidatorId();
        if (currentId) {
          const index = this.consolidatorOptions.findIndex(
            (opt) => opt.id === currentId,
          );
          if (index >= 0) {
            this.selectedConsolidatorIndex = index;
          }
          return;
        }

        const first = this.consolidatorOptions[0];
        if (first) {
          this.tabCtx.setConsolidator(first);
          this.consolidatorName = first.name;
        }
      },
      error: (error) => {
        console.error('Error fetching consolidators:', error);
        this.consolidatorLoading = false;
      },
    });
  }

  private showConsolidatorModal() {
    this.consolidatorButtonDisabled = true;
    this.ref = this.dialog.open(this.consolidatorModalTemplate, {
      width: this.isMobile ? '328px' : '414px',
      panelClass: 'modal',
    });
  }

  onConsolidatorSelected() {
    this.consolidatorButtonDisabled = false;
  }

  applyConsolidator() {
    const selected = this.consolidatorOptions[this.selectedConsolidatorIndex];
    if (selected) {
      this.tabCtx.setConsolidator(selected);
      this.consolidatorName = selected.name;
      this.closeConsolidatorModal();
      window.location.reload();
    }
  }

  closeConsolidatorModal() {
    this.selectedConsolidatorIndex = 0;
    if (this.ref) {
      this.ref.close();
    }
  }
}
